import type { Stripe } from "@stripe/stripe-js"
import { loadStripe } from "@stripe/stripe-js"
import { getEnv } from "@holigral/shared/utils"

let promise: Promise<Stripe | null> | undefined

/**
 * Lazily loads Stripe.js, client-side only. Unlike a module-top loadStripe,
 * the publishable key is read on first call — which only happens inside the
 * ClientOnly Elements provider — so SSR/prerender never sees an empty key.
 */
export default function getStripe(): Promise<Stripe | null> {
  promise ??= loadStripe(getEnv("STRIPE_PUBLISHABLE"))

  return promise
}
